module.exports = " <div> <router-view></router-view> <check></check> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/App.vue
 ** module id = 161
 ** module chunks = 31
 **/